/**
* Full Width Left Right JS
* -----------------------------------------------------------------------------
*
* All the JS for the Full Width Left Right component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
// import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'full-width-left-right',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.full-width-left-right' ).each( function( key, val ) {
        const backgroundImage = $( val ).find( '.full-width-left-right__large-image' )[0];

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: $( val ).find( '.image-wrapper' ),
            start: 'top 100%',
            end: 'bottom 15%',
            scrub: 1,
          },
        } );

        if ( backgroundImage ) {
          tl.to( backgroundImage, {y: '6%', ease: 'linear'}, 0 );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'full-width-left-right', COMPONENT );
} )( app );
